import React, { useState, useContext, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { APIContext } from '../Contexts/APIContext';
import Typography from '@mui/material/Typography';

type Props = {
    close: () => void;
    id: number;
}

export default function ScorecardPreviewTitleBar({ close, id }: Props) {
    const { get } = useContext(APIContext);
    const [title, setTitle] = useState('');

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        get('ScorecardManagement', `GetPreviewTitle?templateId=${id}`, (data) => {
            setTitle(data);
        });
    }

    return (
        <AppBar position="static" color="default" >
            <Toolbar variant="dense">
                <Button variant="outlined" onClick={close} sx={{ ml: -2, mr: 2 }}>Back</Button>
                <Typography variant="h6">{title}</Typography>
            </Toolbar>
        </AppBar>
    )
}